import React, { useMemo, useState } from 'react';
import FormContainer from '../../../Components/Form/FormContainer';
import BaseModal from '../../Base/Components/BaseModal/BaseModal';
import { useTermItemsQuery } from '../../../graphql/graphql';
import Loading from '../../../Components/Loading';
import { MagicField } from '../../../Enums/MagicField.enum';
import MagicFormItem, { ItemScheme } from '../../../Components/Form/MagicFormItem';
import AddButton from '../../../Components/Button/AddButton';
import { Position } from '../../Base/Enums/Position.enum';
import { useAppContext } from '../../../Services/AppContext';
import Button from '../../../Components/Button/Button';
import { Theme } from '../../../Enums/Theme.enum';

interface Props {
	name: string;
	inputType: MagicField;
}

const MagicFormTranslations: React.FC<Props> = ({ name, inputType }) => {
	const { language } = useAppContext();
	const { data: languagesData, isLoading: languagesAreLoading } =
		useTermItemsQuery({
			termType: 'language_grouped',
			take: 999,
		});

	const [isOpen, setIsOpen] = useState(false);

	const items: ItemScheme[] = useMemo(() => {
		const temp: ItemScheme[] = [];
		languagesData?.termItems?.data?.forEach((item) => {
			if (item?.value?.split('_')[0] !== language && item?.name && item?.value) {
				temp.push({
					type: inputType,
					label: item.name,
					key: item.value,
				} as ItemScheme)
			}
		});
		return temp;
	}, [languagesData])

	const handleClose = () => {
		setIsOpen(false)
	}

	if (languagesAreLoading) {
		return <Loading />;
	}

	return (
		<div style={{ marginBottom: '10px' }}>
			<AddButton
				title='component.inputTranslations.addTranslations'
				onClick={() => setIsOpen(true)}
				iconPosition={Position.LEFT}
			/>
			<FormContainer name={name} settings={{ showLine: false }}>
				<BaseModal
					title='component.inputTranslations.translations'
					isOpen={isOpen}
					onClose={handleClose}>
					<>
						{items.map((item) => <MagicFormItem itemScheme={item} />)}
						<Button
							theme={Theme.GREEN}
							title='base.shared.add'
							fitContent
							onClick={handleClose}
						/>
					</>
				</BaseModal>
			</FormContainer>
		</div>
	);
};

export default MagicFormTranslations;
